<template>

<div>

    <div v-if="showAddNew">
        <h2 class="mt-6">Ny fråga:</h2>
        <div class="new-list-group-item new-list-group-item-add">

            <div class="row pb-4">
                <div class="col-2 align-items-start">

                </div>
                <div class="col-9 d-flex align-items-start">
                    <div class="w-100">
                        <label style="font-weight: 600;">Fråga</label>
                        <textarea class="form-control" style="height: 86px;" v-model="title"></textarea>
                    </div>
                </div>
                <div class="col-10 d-flex align-items-start">
                    <label style="font-weight: 600;">Svar</label>
                    <textarea class="form-control" style="height: 260px;" v-model="answer"></textarea>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-start pt-7">
                    <button class="btn btn-primary btn-sm" :disabled="poster.submitted" @click="posterPost()">
                        <span class="spinner-border spinner-border-sm"></span>
                        Spara
                    </button>
                </div>
            </div>

        </div>
    </div>

    <div class="w-100 d-flex justify-content-end pt-6" v-else>
        <button class="btn btn-primary btn-sm" @click="showAddNew = true">
            Lägg till ny fråga
        </button>
    </div>

</div>

</template>

<script>
import poster from '../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        type: {
            required: true
        }
    },

    data () {
        return {
            title: '',
            answer: '',
            showAddNew:false
        }
    },

    computed: {
        posterUrl () {
            return '/faq-pages'
        },
        posterData () {
            return {
                title: this.title,
                answer: this.answer,
                type: this.type
            }
        }
    },

    methods: {
        posterSuccess () {
            this.title = ''
            this.answer = ''
            this.showAddNew = false

            bus.$emit(
                'notify',
                'Frågan har lagts till.'
            )

            this.$emit('refresh')

        }
    }
}
</script>
